/**
 *
 */



class DataAnalysis {

	constructor(resultData, or34) {

		this._or34 = or34;

		this._resultData = resultData;

		this._resultDataArr = this._resultData.array;


		//this._categBaseFactory = new CategBaseFactory(this._resultDataArr, or34);
		this._hangar = new DataHangar(this._resultDataArr, or34);

		//  各回号ごとの０－9の出現個数
		this._numberCountArray = this._setNumberCountArray();

		this._rangeArray = [   10, 50, 100, 500, 1000, 2000,  this._resultDataArr.length   ];

		this._theory = this._or34*10;
		this._numbTheory = this._getNumbTheory()/Math.pow(10, this._or34-2);

		//  rangeArrayごとの総出現個数の理論値
		this._rangeTheoryArray;
		//  rangeArrayごとの総出現回数の理論値
		this._rangeNumbTheoryArray;
		//  _rangeTheoryArray と _rangeNumbTheoryArray を SET
		this._setRangeTheoryArray();

		//  rangeArrayごとの総出現個数の誤差理論値
		this._rangeErrorTheoryArray;
		//  rangeArrayごとの総出現回数の誤差理論値
		this._rangeNumbErrorTheoryArray;
		//  _rangeErrorTheoryArray と _rangeNumbErrorTheoryArray を SET
		this._setRangeErrorTheoryArray();


		// rangeArrayごとの０－９の総出現個数
		this._countRangeArray;
		// rangeArrayごとの０－９の総出現回数
		this._countRangeNumbArray;
		//  _countRangeArray と _countRangeNumbArrayを SET
		this._setCountRangeArray();


		//
		this._interval = [   5, 10, 20, 50   ];
		this._countIntervalArray;
		this._countIntervalNumbArray;

		this._setIntervalCount();

		this._itvTheory;
		this._itvNbTheory;
		this._setIntervalTheory();



		//
		this._CATEGORY = [   'baseCount', 'baseTimes'   ];
		this._HEAD_TEXT = [    '出現　個数',  '出現　回数'   ];


		this._beanMap = new Map();
		var map = new Map();
		for(let i=0; i<10; i++) {

			let bean = new DataAnalBean(or34, this._CATEGORY[0], this._theory,
					this._rangeTheoryArray, this._countRangeArray[i], this._rangeErrorTheoryArray, this._HEAD_TEXT[0]);
			bean.intervalCountArray = this._countIntervalArray[i];
			bean.intervalTheoryArray = this._itvTheory;
			map.set(i, bean );
		};
		this._beanMap.set(this._CATEGORY[0], map);

		map = new Map();
		for(let i=0; i<10; i++) {

			let bean = new DataAnalBean(or34, this._CATEGORY[1], this._numbTheory,
					this._rangeNumbTheoryArray, this._countRangeNumbArray[i], this._rangeNumbErrorTheoryArray,
					this._HEAD_TEXT[1]);

			bean.intervalCountArray = this._countIntervalNumbArray[i];
			bean.intervalTheoryArray = this._itvNbTheory;
			map.set(i, bean );
		};
		this._beanMap.set(this._CATEGORY[1], map);
		//


		//   test
		/*
		console.log(this._countIntervalArray.length);
		for(let i=0; i<this._countIntervalArray.length; i++) {
			console.log(this._countIntervalArray[i]);
		}
		*/


	};

	get theory() {   return this._theory;   };
	get numbTheory() {   return this._numbTheory;   };

	get numberCountArray() {   return this._numberCountArray;   };
	get rangeArray() {   return this._rangeArray;   };
	get rangeTheoryArray() {   return this._rangeTheoryArray;   };
	get rangeNumbTheoryArray() {   return this._rangeNumbTheoryArray;   };

	get rangeErrorTheoryArray() {   return this._rangeErrorTheoryArray;   };
	get rangeNumbErrorTheoryArray() {   this._rangeNumbErrorTheoryArray;   };

	get countRangeArray() { return this._countRangeArray;   };
	get countRangeNumbArray() {   this._countRangeNumbArray;   };

	get beanMap() {   return this._beanMap;   }


	_setNumberCountArray() {

		//let nbArr = this._categBaseFactory.nb;
		let nbArr = this._hangar.nb;

		let countArr = [];
		for(let i=0, n=nbArr.length; i<n; i++) {
			let countInn = new Uint8Array(10);
			for(let j=0, m=nbArr[i], o=m.length; j<o; j++) {
				for(let k=0; k<10; k++) {
					if(m[j]===k) {
						countInn[k]++;
					};
				};
			};
			countArr.push(countInn);
		};
		return countArr;
	};


	_setCountRangeArray() {
		let countRangeArr = [];
		let countRangeNumbArr = [];

		for(let i=0, n=this._numberCountArray[0].length; i<n; i++) {

			let countArr = MyUtility.makeFillArray( this._rangeArray.length, 0);
			let countNumbArr = MyUtility.makeFillArray( this._rangeArray.length, 0);
			let count = 0;
			for(let arr=this._numberCountArray, j=arr.length-1; j>=0; j--) {
				for(let k=0, range=this._rangeArray, m=range.length; k<m; k++) {
					if(range[k]>count) {
						if(arr[j][i]>0) {
							countArr[k] += arr[j][i];
							countNumbArr[k]++;
						};
					};
				};
				count++;
			};
			countRangeArr.push(countArr);
			countRangeNumbArr.push(countNumbArr);
		};
		this._countRangeArray = countRangeArr;
		this._countRangeNumbArray = countRangeNumbArr;
	};


	_setRangeTheoryArray() {

		//let thPerDef = this._categBaseFactory.basePercentMap.get('base1')[0];
		let thPerDef = this._hangar.basePercentMap.get('base1')[0];

		let all = Math.pow(10, this._or34);
		let thPer = all-thPerDef;
		let rangeThArr = [];
		let rangeNbThArr = [];
		for(let i=0, range=this._rangeArray, n=range.length; i<n; i++) {
			rangeThArr.push( range[i]*this._or34/10 );
			rangeNbThArr.push( range[i]*thPer/all );
		};
		this._rangeTheoryArray = rangeThArr;
		this._rangeNumbTheoryArray = rangeNbThArr;
	};


	_setRangeErrorTheoryArray() {

		//let thPerDef = this._categBaseFactory.basePercentMap.get('base1')[0];
		let thPerDef = this._hangar.basePercentMap.get('base1')[0];

		let all = Math.pow(10, this._or34);
		let thPer = all-thPerDef;
		let rangeErrThArr = [];
		let rangeNbErrThArr = [];
		for(let i=0, range=this._rangeArray, n=range.length; i<n; i++) {
			rangeErrThArr.push( Math.sqrt( range[i] )*this._or34/10 );
			rangeNbErrThArr.push( Math.sqrt( range[i] )*thPer/all );
		};
		this._rangeErrorTheoryArray = rangeErrThArr;
		this._rangeNumbErrorTheoryArray = rangeNbErrThArr;
	};

	_setIntervalCount() {
		let intervalArr = [];
		let intervalNumbArr = [];

		for(let i=0, n=this._numberCountArray[0].length; i<n; i++) {

			let intArr = [];
			let intNumbArr = [];

			for(let j=0, m=this._interval.length; j<m; j++) {
				intArr.push( MyUtility.makeFillArray( 10, 0) );
				intNumbArr.push( MyUtility.makeFillArray( 10, 0) );
			};
			let count = 0;
			for(let arr=this._numberCountArray, j=arr.length-1; j>=0; j--) {

				for(let k=0, intv=this._interval, m=intv.length; k<m; k++) {
					if(count < intv[k]*10) {
						if(arr[j][i]>0) {
							intArr[k][Math.floor(count/intv[k])] += arr[j][i];
							intNumbArr[k][Math.floor(count/intv[k])]++;
						};
					}else {
						if(count >= intv[m-1]*10) {   break;   };
					};
				};
				count++;
			};
			intervalArr.push(intArr);
			intervalNumbArr.push(intNumbArr);
		};
		this._countIntervalArray = intervalArr;
		this._countIntervalNumbArray = intervalNumbArr;
	};

	_setIntervalTheory() {
		let itvTh = [];
		let itvNbTh = [];
		for(let i=0, n=this._interval.length; i<n; i++) {
			itvTh.push(this._interval[i]*this._theory/100);
			itvNbTh.push(this._interval[i]*this._numbTheory/100);
		};
		this._itvTheory = itvTh;
		this._itvNbTheory = itvNbTh;
	};




	_getNumbTheory() {

		//let thPerDef = this._categBaseFactory.basePercentMap.get('base1')[0];
		let thPerDef = this._hangar.basePercentMap.get('base1')[0];

		let all = Math.pow(10, this._or34);
		return all-thPerDef;
	};













};